module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/3-735e26d10cc3bd8b461d616c1c4fb1fc.jpg";